import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Informe} from '../../interfaces/interfaces';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-informe',
  templateUrl: './informe.component.html',
  styleUrls: ['./informe.component.scss'],
})
export class InformeComponent {
  @Input() estado: string;
  @Input() informe: Informe;

  constructor(
    public modalCtrl: ModalController,
    public shared: SharedService
  ) {}

}
